import React from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ROUTE_PROMPT } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const VideoStart = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "#FE845A",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px",
        color: "#ffffff",
        fontFamily: "'Poppins', sans-serif",
        overflow: "hidden",
        boxSizing: "border-box",
        maxHeight: "100vh",
      }}
    >
      <img
        src="images/Seevi-Logo-White.png"
        alt=""
        style={{ width: "109px", height: "58px", marginBottom: "20px", top: "2px", position: "absolute" }}
      />

      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/9a279926f5968dd284eadea876740cae4d9b2d5f151b00029f0d8a7926ba9262?apiKey=d94ace7eb9234970be6d52e95c888888&"
        alt=""
        style={{
          borderRadius: "50%",
          width: "101px",
          height: "101px",
          marginBottom: "20px",
          marginTop: "30px",
        }}
      />

      <Typography
        textAlign="center"
        sx={{
          fontSize: "18px",
          marginTop: "5px",
        }}
      >
        Bring out your best side with videos in 3 simple steps
      </Typography>

      <Stack direction="column" alignItems="center" sx={{ marginBottom: "20px", mt: 2 }}>
        {[1, 2, 3].map((item, index) => (
          <React.Fragment key={item}>
            <Stack direction="column" alignItems="center" sx={{ mt: index !== 0 ? 1 : 0 }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  marginTop: "5px",
                }}
              >
                {item === 1
                  ? "1. Select a prompt"
                  : item === 2
                  ? "2. Practise your concise reply"
                  : item === 3
                  ? "3. Record"
                  : null}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                {item === 1
                  ? "Select one prompt from each of the 3 categories"
                  : item === 2
                  ? "Make sure you are giving your best while practicing"
                  : item === 3
                  ? "Go to your mobile camera and record video. Come back and upload on SeeVi app"
                  : null}
              </Typography>
            </Stack>
            {index !== 2 && <Divider sx={{ backgroundColor: "#ffffff", mt: 2, mb: 0, width: "100%" }} />}
          </React.Fragment>
        ))}
      </Stack>

      <Box sx={{ width: "100%", textAlign: "center" }}>
        <Button
          onClick={() => navigate(ROUTE_PROMPT)}
          sx={{
            padding: "15px 50px",
            color: "#756DE9",
            backgroundColor: "#ffffff",
            borderRadius: "99px",
            fontSize: "16px",
            fontWeight: "600",
            textTransform: "capitalize",
            width: "100%",
            "&:hover": {
              backgroundColor: "#ffffff",
            },
            marginTop: "45px",
          }}
          variant="contained"
          size="small"
        >
          Got It
        </Button>
      </Box>
    </Box>
  );
};

export default VideoStart;
